import angular from 'angular';

import SubscribeComponent from './subscribe.cmpt';

export default angular
    .module('application.scene.authorized.scene.subscribe', [])
    .component(SubscribeComponent.selector, SubscribeComponent)
    .config(stateConfiguration);

/* @ngInject */
function stateConfiguration($stateProvider) {
    $stateProvider.state('authorized.subscribe', {
        url: '/subscribe',
        component: SubscribeComponent.selector
    });
}



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/subscribe/index.js